module.exports = __webpack_public_path__ + "static/media/Icon-suspension.8d131859.svg";